import { useQuery } from '@tanstack/react-query';
import apiClient from "./apiClient";

const getCheeseImage = async (id: number, x: number, y: number): Promise<Blob | null> => {
    try {
      const response = await apiClient.get(`/fromage/${id}/image?x=${x}&y=${y}`, {
        responseType: "blob",
      });
  
      return response.data;
    } catch (error) {
      // console.error("Failed to fetch cheese image:", error);
      return null;
    }
  };

export const useCheeseImage = (id: number, x: number, y: number) => {
  return useQuery({
    queryKey: ['cheeseImage', id, x, y],
    queryFn: () => getCheeseImage(id, x, y),
    enabled: !!id,
  });
};

export default getCheeseImage;